/**
 * Hide Recharge cart count selector and quantity selector
 * Overrides the [data-recharge-cart-count] selector and quantity selector
 */

(function() {
  'use strict';

  const HIDDEN_STYLE = 'display: none !important; visibility: hidden !important; opacity: 0 !important; height: 0 !important; width: 0 !important; overflow: hidden !important; pointer-events: none !important;';

  function hideCartCount() {
    // Target the Recharge cart count selector
    const cartCountElements = document.querySelectorAll('[data-recharge-cart-count]');
    cartCountElements.forEach(element => {
      element.style.cssText = HIDDEN_STYLE;
    });
  }

  function hideQuantitySelector() {
    // Target the quantity selector using the specific DOM path
    const quantitySelector = document.querySelector('#cart-drawer > div > section > div > div.flex.items-center > div > div:nth-child(2) > div');
    if (quantitySelector) {
      quantitySelector.style.cssText = HIDDEN_STYLE;
    }
    
    // Also try alternative selectors in case the structure varies
    const alternativeSelectors = [
      '#cart-drawer div.flex.items-center div:nth-child(2) div',
      '#cart-drawer .flex.items-center > div > div:nth-child(2) > div',
      'div.flex.items-center.rounded-storefront-drawer'
    ];
    
    alternativeSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        // Check if it contains quantity input or buttons
        if (element.querySelector('input[data-slot="input"][aria-label="Quantity"]') ||
            element.querySelector('button[data-slot="button"]')) {
          element.style.cssText = HIDDEN_STYLE;
        }
      });
    });
  }

  function hideAll() {
    hideCartCount();
    hideQuantitySelector();
  }

  // Run immediately
  hideAll();

  // Run after delays to catch late-loading elements
  setTimeout(hideAll, 100);
  setTimeout(hideAll, 500);
  setTimeout(hideAll, 1000);
  setTimeout(hideAll, 2000);

  // Watch for cart drawer opening/closing
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-drawer-toggle], [data-cart-drawer], .cart-drawer')) {
      setTimeout(hideAll, 50);
      setTimeout(hideAll, 200);
      setTimeout(hideAll, 500);
      setTimeout(hideAll, 1000);
    }
  });

  // Use MutationObserver to watch for dynamically added elements
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            // Check if the added node is the cart count or contains it
            if (node.hasAttribute && node.hasAttribute('data-recharge-cart-count')) {
              shouldCheck = true;
            }
            if (node.querySelector && node.querySelector('[data-recharge-cart-count]')) {
              shouldCheck = true;
            }
            // Check if it's the quantity selector
            if (node.className && typeof node.className === 'string' && 
                (node.className.includes('flex') && node.className.includes('items-center'))) {
              shouldCheck = true;
            }
            if (node.querySelector && (
                node.querySelector('input[data-slot="input"][aria-label="Quantity"]') ||
                node.querySelector('button[data-slot="button"]')
            )) {
              shouldCheck = true;
            }
          }
        });
      }
      // Also check if attributes changed
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-recharge-cart-count') {
        shouldCheck = true;
      }
    });
    
    if (shouldCheck) {
      hideAll();
    }
  });

  // Observe the entire document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-recharge-cart-count']
  });

  // Watch for when cart drawer becomes visible
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    const drawerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isOpen = !cartDrawer.classList.contains('cv-h') || 
                        cartDrawer.classList.contains('js-drawer-open-cart');
          if (isOpen) {
            setTimeout(hideAll, 100);
            setTimeout(hideAll, 500);
            setTimeout(hideAll, 1000);
          }
        }
      });
    });
    
    drawerObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

})();

